import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = { class: "inner_container" }
const _hoisted_5 = { class: "field-group" }
const _hoisted_6 = { class: "bold-name" }
const _hoisted_7 = { class: "file-list" }
const _hoisted_8 = {
  key: 0,
  class: "dialog-table"
}
const _hoisted_9 = { style: {"font-weight":"500","color":"black","font-size":"14px","text-transform":"unset","vertical-align":"bottom"} }
const _hoisted_10 = { class: "row no-wrap" }
const _hoisted_11 = { style: {"font-weight":"500"} }
const _hoisted_12 = { style: {"font-weight":"500"} }
const _hoisted_13 = {
  key: 2,
  style: {"font-size":"12px","color":"#499259","margin-right":"5px"}
}
const _hoisted_14 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_15 = { style: {"font-size":"12px","font-weight":"500"} }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = {
  key: 0,
  style: `text-align: left; margin-left: 6px;`
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  style: `text-align: left; margin-left: 6px;`
}
const _hoisted_20 = {
  key: 1,
  class: "cell-actions"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "q-ml-sm" }
const _hoisted_23 = { class: "field-group" }
const _hoisted_24 = { class: "bold-name" }
const _hoisted_25 = { class: "dialog-button" }
const _hoisted_26 = { class: "row no-wrap justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_bill_row = _resolveComponent("bill-row")!
  const _component_movement_row = _resolveComponent("movement-row")!
  const _component_payment_progress = _resolveComponent("payment-progress")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('finances_and_params')), 1),
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          icon: "close",
          size: "md",
          color: "accent",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('finances')), 1),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.tmp_connections.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.tmp_connections[0].name) + ":", 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('quantity_short')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('amount_lower')), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmp_connections.slice(1), (row, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: 'conn_line_' + idx
                        }, [
                          _createElementVNode("td", {
                            style: _normalizeStyle(
                      row.header_row ? 'padding: 5px; padding-top: 16px;' : ''
                    )
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(!row.header_row ? row.idx + "." : "") + " ", 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(row.header_row ? row.name+":" : ""), 1),
                              (!row.header_row && row.connection.bill)
                                ? (_openBlock(), _createBlock(_component_bill_row, {
                                    key: 0,
                                    el: row.connection.bill,
                                    "bill-type": row.connection.billRowType
                                  }, null, 8, ["el", "bill-type"]))
                                : (!row.header_row && row.connection.movement)
                                  ? (_openBlock(), _createBlock(_component_movement_row, {
                                      key: 1,
                                      el: row.connection.movement
                                    }, null, 8, ["el"]))
                                  : _createCommentVNode("", true),
                              (!row.header_row && row.connection.percent < 100)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.connection.percent) + "% ", 1))
                                : _createCommentVNode("", true),
                              (!row.header_row && row.connection.percent < 100)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_payment_progress, {
                                      narrow: false,
                                      width: 50,
                                      percent: Math.round(row.connection.percent)
                                    }, null, 8, ["percent"]),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(row.connection.debit), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 4),
                          _createElementVNode("td", {
                            colspan: row.header_row ? 3 : 1,
                            style: _normalizeStyle(
                      row.header_row ? 'border-left: 0;' : ''
                    )
                          }, [
                            (!row.header_row && row.connection.movement)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.connection.movement
                          .Items, (storagepos, idsx) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'stp' + idsx
                                    }, _toDisplayString(storagepos.ItemQuantity), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 12, _hoisted_16),
                          (!row.header_row)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                _createTextVNode(_toDisplayString(row.connection.amount) + " ", 1),
                                (row.connection.movement)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.connection.movement
                          .Items, (storagepos, idsx) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: 'stp' + idsx
                                        }, _toDisplayString(storagepos.TotalAmount), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (!row.header_row)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                _createElementVNode("span", {
                                  class: "table-remove",
                                  title: _ctx.$t('remove')
                                }, [
                                  _createVNode(_component_app_icon, {
                                    name: "close",
                                    width: "16px",
                                    color: "#979797",
                                    "hover-color": "#616161",
                                    cursor: "pointer"
                                  }),
                                  _createVNode(_component_q_menu, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_card, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_card_section, { class: "row items-center" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_app_icon, {
                                                name: "delete-outline",
                                                width: "18px",
                                                color: "#979797"
                                              }),
                                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("sure_delete")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_card_actions, { align: "right" }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                size: "sm",
                                                flat: "",
                                                label: _ctx.$t('cancel'),
                                                color: "dark",
                                                ref_for: true,
                                                ref: 'cancelbtn' + idx
                                              }, null, 8, ["label"]), [
                                                [_directive_close_popup]
                                              ]),
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                size: "sm",
                                                flat: "",
                                                label: _ctx.$t('remove'),
                                                autofocus: "",
                                                color: "dark",
                                                ref_for: true,
                                                ref: 'okbtn' + idx
                                              }, null, 8, ["label"]), [
                                                [_directive_close_popup]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 8, _hoisted_21)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('parameters')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerModel.Parameters, (params, pid) => {
              return (_openBlock(), _createElementBlock("table", {
                class: "dialog-table",
                key: 'ptable_' + pid,
                ref_for: true,
                ref: 
              (el) => {
                _ctx.triggerEls[pid] = el;
              }
            
              }, [
                (_ctx.triggerEls[pid])
                  ? (_openBlock(), _createBlock(_component_parameter_inline, {
                      key: 0,
                      "is-root": true,
                      editable: "",
                      "is-table": "",
                      id: 'project-param-' + pid,
                      modelValue: _ctx.parameters_model[pid],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.parameters_model[pid]) = $event),
                      "token-styles": _ctx.tokenStyles,
                      "show-custom": false,
                      "context-trigger": _ctx.triggerEls[pid],
                      "create-mode": false
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "token-styles", "context-trigger"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_q_btn, {
            label: _ctx.$t('cancel_short'),
            "no-caps": "",
            flat: "",
            onClick: _ctx.close
          }, null, 8, ["label", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}